import { memberApi } from '../config/axios-config';

export const sendSecureMessageApi = (membersDetail, subject, userMessage,tenantId) => {
    return memberApi.post('/v3/my/sendSecureMessage', {membersDetail, subject , userMessage }, {
        headers: {
            'tenant-id': tenantId,
        }
    }
    );
};